export enum ScreenSize {
    xs,
    md,
    lg
}